<template>
  <div id="app">
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("LoadDetail");
  },
  mounted() {
  },
};
</script>
<style lang="scss">
.mx__btn--ok {
  background:$dig-btn-bg;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
  transform-origin: top;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}
</style>
